import { Helmet } from 'react-helmet'
import { useSession } from 'contexts/session-context'
import useRouter from 'hooks/use-router'
import useRedirect from 'hooks/use-redirect'
import ComingNextSection from 'views/neighbars/components/ComingNextSection'
import CtaVideoSection from 'views/neighbars/components/CtaVideoSection'
import Hero from './components/Hero'
import IntroSection from './components/IntroSection'
import HistorySection from './components/HistorySection'
import ProcessSection from './components/ProcessSection'
import KvSection from './components/KvSection'
import GallerySection from './components/GallerySection'
import StoresSection from './components/StoresSection'

const SEO_TITLE = 'Credenciales | My Heineken'
const SEO_DESCRIPTION =
  'Descubre qué hace que Heineken tenga un sabor de calidad: 100% pura malta, ingredientes naturales y más de 150 años de maestría cervecera.'

const Credenciales = () => {
  const [{ user }] = useSession()
  const { push, pathname } = useRouter()
  const [, { setRedirect }] = useRedirect()

  const isLogged = user !== undefined

  const goToStart = () => {
    setRedirect(pathname)
    push('/start')
  }

  return (
    <div className="credenciales">
      <Helmet>
        <title>{SEO_TITLE}</title>
        <meta name="description" content={SEO_DESCRIPTION} />
        <meta property="og:title" content={SEO_TITLE} />
        <meta property="og:description" content={SEO_DESCRIPTION} />
        <meta property="og:type" content="website" />
      </Helmet>
      <Hero />
      <IntroSection />
      <HistorySection />
      <ProcessSection />
      <KvSection />
      <GallerySection />
      <StoresSection />
      <CtaVideoSection />
      <ComingNextSection showCta={!isLogged} onCtaClick={goToStart} trackSection="credenciales" />
    </div>
  )
}

export default Credenciales
